import AddPatient from 'components/patient/add-patient/AddPatient';
import React from 'react';
import { Modal } from 'react-bootstrap';

const AddDayProgramPatientModal = ({ show, onHide }) => {
    return (
        <>
            <style>{`
                .modal-body::-webkit-scrollbar {
                    display: none;
                }
                .modal-body {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
            `}</style>
            <Modal size='xl' show={show} onHide={onHide} scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Add Day Program Patient</Modal.Title>
                </Modal.Header>
                <Modal.Body className='p-0'>
                    <AddPatient isDayProgram={true} onHide={onHide} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddDayProgramPatientModal;